import { isGlobalworth, paths } from 'config'
import { DrawerOrganizations, Organizations } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.organizations,
    admin: true,
    canShowOrganizations: true,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Organizations : DrawerOrganizations,
      label: 'nav.organizations',
    },
    component: Loadable({
      component: () => import('./pages/Organizations'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addOrganization,
    admin: true,
    canShowOrganizations: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddOrganization'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.organization,
    admin: true,
    canShowOrganizations: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Organization'),
    }),
    layoutSettings: {},
  },
]

export default routes
